import React, { useState, useEffect, useMemo } from "react";
import { convertToCloudFrontUrl } from "../../helper";

const PreviewImage = (props) => {
    const { image, label, uploadMedia, mediaError, error, note } = props;
    
    const [imageDimensions, setImageDimensions] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    // Reset error state when image changes
    useEffect(() => {
        setImageError(false);
        setImageLoaded(false);
        setImageDimensions(null);
    }, [image]);

    const handleImageLoad = (event) => {
        const { naturalWidth, naturalHeight } = event.target;
        setImageDimensions({ width: naturalWidth, height: naturalHeight });
        setImageLoaded(true);
    };

    // Memoize image source calculation to prevent recalculation on every render
    const imageSrc = useMemo(() => {
        if (!image || typeof image !== 'string' || image.trim() === '') {
            return null;
        }
        
        // If it's a blob URL, use it directly
        if (image.startsWith('blob:')) {
            return image;
        }
        
        // Otherwise, convert to CloudFront URL
        return convertToCloudFrontUrl(image);
    }, [image]);

    // Only show "NO COVER" if there's no image source AND no error
    const showNoCover = !imageSrc && !imageError;

    return (
        <div className="mt-3 d-flex flex-column align-items-start">
            <label className="label">{label}:</label>
            <input
                className="file"
                type="file"
                name="images"
                accept=".png, .jpg, .jpeg, .webp, .svg, .gif"
                multiple
                onChange={(e) => uploadMedia(e)}
                onClick={(e) => { e.target.value = null }}
            />
            {imageSrc && !imageError ? (
                <>
                    <label className="label mt-3">Image Preview:</label>
                    <img
                        src={imageSrc}
                        alt="preview"
                        height={250}
                        width={225}
                        style={{ borderRadius: "12px", border: "1px solid var(--ps-border)" }}
                        onLoad={handleImageLoad}
                        onError={(e) => {
                            console.error('[Preview Image Error] Failed to load:', {
                                url: imageSrc,
                                originalUrl: image,
                                isBlobUrl: image && image.startsWith('blob:')
                            });
                            setImageError(true);
                        }}
                    />
                </>
            ) : showNoCover ? (
                <>
                    <label className="label mt-3">Image Preview:</label>
                    {/* Inline, so theme.css cannot reach it — the tokens are
                        read off the document instead of hard-coded twice. */}
                    <div style={{
                        height: 250,
                        width: 225,
                        borderRadius: "12px",
                        border: "1px solid var(--ps-border)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "var(--ps-surface-2)",
                        color: "var(--ps-text-muted)"
                    }}>
                        NO COVER
                    </div>
                </>
            ) : null}

            {note && imageSrc && !imageError && (
                <p className="text-muted mt-2 mb-0"><em>{note}</em></p>
            )}

            {imageLoaded && imageDimensions && (
                <p className="text-muted mt-2">
                    Uploaded Original Size: <strong>{imageDimensions.width} × {imageDimensions.height} px</strong>
                </p>
            )}

            {mediaError &&
                <p className="error-message d-block">{mediaError}</p>
            }

            {error &&
                <p className="error-message d-block">{error}</p>
            }

        </div>
    );
};

export default PreviewImage;